<div class="wrapper" [ngStyle]="{'margin': margin}">
  <ng-content></ng-content>
    <!-- <div class="layout">
      <ng-content select="[layout]"></ng-content>
    </div> -->
</div>

